module.exports = __webpack_public_path__ + "static/media/popup.11d396c4.webp";